'use client'

import LocalisationAndTime from '@/components/global/LocalisationAndTime'
import Z_Logo_Gradient     from '@/components/global/Z_Logo_Gradient'
import styles              from './Header.module.sass'

const Header = ({header}) => {
	return (<header className={styles.header}>
		<Z_Logo_Gradient ariaLabel={header.zibenLogoAriaLabel}/>

		<LocalisationAndTime
			hideOnMobile
			data={header}
		/>
	</header>)
}

export default Header
